// Полночь по местному времени через `days` дней от дня `date` (`days = 0` — начало того же дня).
export const addDays = (date: Date, days: number): Date =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate() + days);
